import React from 'react'

const MasterCard = (props:any) => {
  return (
    <svg width={35} height={25} fill="none" {...props}>
    <path fill="#FF5F00" d="M21.597 5.171h-8.139v14.625h8.139V5.17Z" />
    <path
      fill="#EB001B"
      d="M13.976 12.483a9.285 9.285 0 0 1 3.552-7.312 9.301 9.301 0 1 0 0 14.624 9.284 9.284 0 0 1-3.552-7.312Z"
    />
    <path
      fill="#F79E1B"
      d="M32.577 12.483a9.3 9.3 0 0 1-15.048 7.312 9.302 9.302 0 0 0 0-14.624 9.3 9.3 0 0 1 15.048 7.312ZM31.69 18.247v-.3h.12v-.06h-.308v.06h.121v.3h.066Zm.596 0v-.361h-.094l-.108.248-.109-.248h-.094v.36h.066v-.272l.102.235h.069l.102-.235v.273h.066Z"
    />
  </svg>
  )
}

export default MasterCard